<template>
  <ChatMessageTemplateModalStructure>
    <template #header>
      <ChatMessageTemplateHeader @close="emit('close')">
        テンプレートの新規作成
      </ChatMessageTemplateHeader>
    </template>

    <template #detail>
      <ChatMessageTemplateEditor
        v-model="form"
        @save="handleSave"
        @cancel="emit('changeMode', 'view')"
      />
    </template>
  </ChatMessageTemplateModalStructure>
</template>

<script lang="ts" setup>
import { ref } from 'vue'

import ChatMessageTemplateHeader from './ChatMessageTemplateHeader.vue'
import ChatMessageTemplateEditor from './ChatMessageTemplateEditor.vue'
import ChatMessageTemplateModalStructure from './ChatMessageTemplateModalStructure.vue'
import { useChatMessageTemplate } from './useChatMessageTemplate'

import { useAlert } from '@/libs/alertPortal'
import { isDefinedRef } from '@/libs/utilities/isDefinedRef'

import type { ChatMessageTemplate } from '@/types/app'
import type { ChatMessageTemplateModalMode } from './types'

const emit = defineEmits<{
  (event: 'close'): void
  (event: 'changeMode', value: ChatMessageTemplateModalMode): void
  (event: 'update:selectedGuid', value: ChatMessageTemplate['guid']): void
}>()

const alert = useAlert()

const { createTemplate } = useChatMessageTemplate()

const getEmptyForm = () => ({
  guid: '',
  label: '',
  body: '',
  selections: [],
})

const form = ref<ChatMessageTemplate>(getEmptyForm())
const clearForm = () => {
  form.value = getEmptyForm()
}

const handleSave = async () => {
  if (!isDefinedRef(form)) {
    return
  }
  const normalizedData = {
    ...form.value,
    selections: form.value.selections.filter(item => item !== ''),
  }
  const { guid, label } = await createTemplate(
    normalizedData.label,
    normalizedData.body,
    normalizedData.selections
  )
  clearForm()
  alert.success(`テンプレート「${label}」を新規保存しました`)
  emit('update:selectedGuid', guid)
  emit('changeMode', 'view')
}
</script>
